/** Swagger API: Notification */
export const NOTIFICATION_ENDPOINT = `notifications/`;
export const NOTIFICATION_EMAIL_NOTIFIER_ENDPOINT = `emails/notifiers`;
export const NOTIFICATION_PHARMACY_ENDPOINT = `clinical-pharmacies/`;

/** Swagger API: Notification create category types */
export const NOTIFICATION_CREATE_QUALITY_DEVIATIONS_ENDPOINT = `quality-deviations`;

/** Swagger API: NotificationType */
export const NOTIFICATION_GET_TYPES_ENDPOINT = `notifications/types/`;

/** Swagger API: NotificationIncident */
export const NOTIFICATION_GET_INCIDENTS_ENDPOINT = `notifications/incidents/`;
export const NOTIFICATION_GET_INCIDENTS_TYPES_ENDPOINT = `notifications/incidents/notification-types/`;

/** Swagger API: NotificationCategories */
export const NOTIFICATION_GET_CATEGORIES_ENDPOINT = `notifications/categories/`;
export const NOTIFICATION_GET_TYPES_CATEGORIES_ENDPOINT = `notifications/types/categories/`;

/** Swagger API: Admissions **/
export const NOTIFICATION_GET_PATIENT_DATA_ANONYMIZEDS_ENDPOINT = `patient-data-anonymizeds/`;
export const NOTIFICATION_GET_ADMISSIONS_PATIENT_DATA_ANONYMIZEDS_ENDPOINT = `admissions/patients/anonymized-data/`;
export const NOTIFICATION_GET_ADMISSIONS_PATIENT_DATA_ENDPOINT = `hospitaladmissions/patientData`;
export const NOTIFICATION_GET_OCCUPATIONS_ENDPOINT = `occupations`;
